<template>
  <div>
    <div class="order">
      <div class="grid-content bg-purple">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-daichuli" />
        </svg>
        <span>{{ statusStr }}</span>
        <div v-if="data.status == 33" class="p_red">
          保费将在1-5个工作日原路退回
        </div>
        <!-- <div v-if="data.status == 7" class="p_red">{{ data.remark }}</div> -->
        <div v-if="data.status == 32" class="p_red">
          {{ data.cancelMessage }}
        </div>
      </div>
      <div class="grid-content bg-purple-light">
        <div class="content_head">
          <span>业务流水号：</span>
          <span>{{ orderNo }}</span
          ><br />
          <span>担保金额：</span>
          <span>￥{{ data.sumAmount }}元</span>
        </div>
        <div class="content_head">
          <span>{{
            ["31", "33", "32"].includes(data.status)
              ? "申请时间："
              : "下单时间："
          }}</span>
          <span>{{ dateFormat(data.createDate) }}</span
          ><br />
          <span>{{
            ["31", "33", "32"].includes(data.status)
              ? "支付保费总计："
              : "应付保费总计："
          }}</span>
          <h3>￥{{ data.sumPremium }}元</h3>
        </div>
        <div>
          <div>
            <button
              class="custom-btn btn-4"
              @click="goBtn(isBtnStr)"
              v-if="isVisBtn"
            >
              <span>{{ isBtnStr }}</span>
            </button>
          </div>
        </div>
        <a-button
          v-if="data.preSignDownloadUrl ||data.signDownloadUrl"
          class="downloadBtn"
          @click="download"
        >
          下载保函
        </a-button>
        <a-button
          v-if="data.isGiveup && data.giveupBut"
          class="downloadBtnTwo"
          @click="goBtn('取消')"
        >
         取消
        </a-button>
      </div>
      
    </div>
    <div v-if="data.status == 21" class="p_tip">
      温馨提示：请仔细校对保函信息是否与招标文件一致，如信息有误请及时拨打客服电话！
    </div>

    <PlateTitle title="投保信息">
      <template v-slot:extra>
        <div class="reding">
          <span>阅读<a @click="rulesShow = true">《投保须知》</a> </span>
        </div>
      </template>
    </PlateTitle>

    <div class="main">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="投标人名称" has-feedback>
          <span>{{ data.name }}</span>
        </a-form-item>
        <a-form-item label="投标人统一社会信用代码" has-feedback>
          <span>{{ data.creditCode }}</span>
        </a-form-item>
        <a-form-item label="标段名称" has-feedback>
          <span>{{ data.sectionName }}</span>
        </a-form-item>
        <a-form-item label="标段编号" has-feedback>
          <span>{{ data.sectionCode }}</span>
        </a-form-item>
        <a-form-item label="招标人名称" has-feedback>
          <span>{{ data.tendereeName }}</span>
        </a-form-item>
        <a-form-item label="招标人统一社会信用代码" has-feedback>
          <span>{{ data.tendereeCreditCode }}</span>
        </a-form-item>
        <a-form-item label="出函机构" has-feedback>
          <div>{{ data.partnerLogoName }}</div>
          <div class="logo_box">
            <!-- <img :src="data.partnerLogoPath" alt="" /> -->
            <img  :src="'data:image/png;base64,'+ data.partnerLogoPathBase64" />
          </div>
        </a-form-item>
        <a-form-item label="保函类型" has-feedback>
          <span>{{ data.guaranteeTypeStr }}</span>
        </a-form-item>
        <a-form-item label="保函有效期" has-feedback>
          <span>{{ data.period }}</span>
        </a-form-item>
        <a-form-item label="经办人" has-feedback>
          <span>{{ data.responsiblePersonName }}</span>
        </a-form-item>
        <a-form-item label="经办人联系方式" has-feedback>
          <span>{{ data.responsiblePersonPhone }}</span>
        </a-form-item>
      </a-form>
    </div>
    <template
      v-if="data.status == '13' || data.status == '14' || data.status == '21'"
    >
      <PlateTitle title="支付信息">
        <!-- <template v-slot:extra>
          <div class="reding">
            <span
              >投保信息有误？点此 <a @click="policyShow = true">申请退保 </a>
            </span>
          </div>
        </template> -->
      </PlateTitle>
      <div class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="支付时间" has-feedback>
            <span>{{ data.payDateStr }}</span>
          </a-form-item>
          <a-form-item label="支付金额" has-feedback>
            <span>{{ data.sumPremium }} 元</span>
          </a-form-item>
        </a-form>
      </div>
    </template>

    <template v-if="data.status == 21 && (data.invoiceStatus == 20 || data.invoiceType == 2)">
      <PlateTitle title="发票信息" subtitle="（发票1-5个工作日内开具）">
        <template v-slot:extra>
          <a-button
            v-if="data.invoiceUrl"
            type="primary"
            @click="goBtn('下载发票')"
          >
            下载发票
          </a-button>
        </template>
      </PlateTitle>
      <div class="main" v-if="data.invoiceType == 3 && data.invoiceStatus == 20">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="开票类型" has-feedback>
            <span>{{ data.invoiceTypeStr }}</span>
          </a-form-item>
          <a-form-item label="快递公司" has-feedback>
            <span>{{ data.expressName }}</span>
          </a-form-item>
          <a-form-item label="电子邮箱" has-feedback>
            <span>{{ data.expressNo }}</span>
          </a-form-item>
        </a-form>
      </div>
      <div v-if='data.invoiceType == 2' class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="开票类型" has-feedback>
            <span>{{ data.invoiceTypeStr }}</span>
          </a-form-item>
          <a-form-item label="发票抬头" has-feedback>
            <span>{{ data.invoiceHead }}</span>
          </a-form-item>
          <a-form-item label="纳税人识别号" has-feedback>
            <span>{{ data.invoiceCuscCode }}</span>
          </a-form-item>
          <a-form-item label="电子邮箱" has-feedback>
            <span>{{ data.invoiceEmail }}</span>
          </a-form-item>
        </a-form>
      </div>
    </template>

    <template
      v-if="
        data.status === '31' || data.status === '32' || data.status === '33'
      "
    >
      <PlateTitle title="退款信息" />
      <div class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="退款账户" has-feedback>
            <span>{{ data.cancelAccountName }}</span>
          </a-form-item>
          <a-form-item label="退款账号" has-feedback>
            <span>{{ data.cancelBankNo }}</span>
          </a-form-item>
        </a-form>
      </div>
    </template>

    <a-modal
      v-model="visible"
      :title="isBtnStr"
      @ok="submit"
      :mask-closable="false"
      ok-text="确认"
      cancel-text="取消"
      class="Invoicing"
    >
      <a-form :form="form" :label-col="{ span: 10 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="业务流水号" v-if="isBtnStr === '退保'">
          <span>{{ orderNo }}</span>
        </a-form-item>
        <a-form-item label="手机号" v-if="isBtnStr !== '开票'">
          <span>{{ data.mobile }}</span>
        </a-form-item>
        <div v-if="isBtnStr === '退保'">
          <!-- <a-form-item label="验证码" class="code" v-if="step === 0">
            <a-input
              v-decorator="[
                'code',
                { rules: [{ required: true, message: '请输入验证码' }] }
              ]"
              placeholder="请输入验证码"
              style="width: 275px"
            />
            <img :src="codeImg" alt="" @click="code" />
          </a-form-item>
          <a-form-item label="短信验证码" class="code" v-if="step === 0">
            <a-input
              v-decorator="[
                'phoneCode',
                { rules: [{ required: true, message: '请输入短信验证码' }] }
              ]"
              placeholder="请输入短信验证码"
              style="width: 275px"
            />
            <a v-if="isTime" @click="phoneCode">获取验证码</a>
            <span v-else>{{ time }}s重新获取</span>
          </a-form-item> -->
          <a-form-item label="投标人名称">
            <span>{{  data.name }}</span>
          </a-form-item>
          <a-form-item label="投标人统一社会信用代码">
            <span>{{ data.creditCode }}</span>
          </a-form-item>
          
          <a-form-item label="退保原因">
            <a-select
              v-decorator="[
                'cancelReason',
                { rules: [{ required: true, message: '请选择退保原因' }] }
              ]"
              style="width: 275px"
            >
              <a-select-option value="项目未开标，不想投标了">
                项目未开标，不想投标了
              </a-select-option>
              <a-select-option value="投标人失误，或选择投标项目错误">
                投标人失误，或选择投标项目错误
              </a-select-option>
              <a-select-option value="因项目变化等其他原因">
                因项目变化等其他原因
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div v-if="isBtnStr === '开票'">
          <a-form-item label="发票抬头">
            <span>{{ data.invoiceHead }}</span>
          </a-form-item>
          <a-form-item label="纳税人识别号">
            <span>{{ data.creditCode }}</span>
          </a-form-item>
          <a-form-item label="手机号">
            <span>{{ data.mobile }}</span>
          </a-form-item>
          <a-form-item label="发票类型">
            <a-select v-model="invoiceType" style="width: 275px">
              <a-select-option
                v-for="(item, index) in typeArray"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <!-- <a-form-item label="开户行">
            <a-input
              v-decorator="[
                'bankInfo',
                { rules: [{ required: true, message: '请输入开户行' }] }
              ]"
              placeholder="请输入开户行"
              style="width: 275px"
            />
          </a-form-item>
          <a-form-item label="开户账号">
            <a-input
              v-decorator="[
                'bankAcc',
                { rules: [{ required: true, message: '请输入开户账号' }] }
              ]"
              placeholder="请输入开户账号"
              style="width: 275px"
            />
          </a-form-item>
          <a-form-item label="联系电话">
            <a-input
              v-decorator="[
                'phoneNo',
                { rules: [{ required: true, message: '请输入联系电话' }] }
              ]"
              placeholder="请输入联系电话"
              style="width: 275px"
            />
          </a-form-item> -->
          <a-form-item label="邮箱">
            <a-input
              v-decorator="[
                'email',
                { rules: [{ required: true, message: '请输入邮箱' }] }
              ]"
              placeholder="请输入邮箱"
              style="width: 275px"
            />
          </a-form-item>
          <!-- <a-form-item label="注册地址">
            <a-input
              v-decorator="[
                'addInfo',
                { rules: [{ required: true, message: '请输入注册地址' }] }
              ]"
              placeholder="请输入注册地址"
              style="width: 275px"
            />
          </a-form-item> -->

          <a-form-item label="备注">
            <a-input
              type="textarea"
              v-decorator="['remark', { rules: [{}] }]"
              placeholder="请输入备注"
              style="width: 275px"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>

    <div class="notice-dialog">
      <a-modal
        class="rules"
        v-model="rulesShow"
        title="保函开立须知"
        centered
        :mask-closable="false"
        :closable="false"
        @cancel="
          () => {
            rulesShow = false;
          }
        "
        @ok="
          () => {
            rulesShow = false;
          }
        "
      >
        <div class="content" v-html="insureNotice" />
        <template v-slot:footer>
          <a-button @click="rulesShow = false" type="primary">
            我知道了
          </a-button>
        </template>
      </a-modal>
    </div>
    <div class="notice-dialog">
      <a-modal
        class="polic"
        v-model="policyShow"
        title="退保申请"
        centered
        :mask-closable="false"
        :closable="true"
        @cancel="policyShow = false"
      >
        <div class="contents">
          退保需要填写退保申请书，申请书及当时付款的凭证需盖章
          后邮寄至：深圳市福田区莲花街道福新社区益田路6013号江苏大厦A、B座A座17层1702 李经理 17788782725
          <div>
            <div class="down">
              点击下载
              <a
                href="/api/insure/index/download?type=refund_application_template"
                target="_blank"
                >《退保申请书模板》
              </a>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <a-button size="large" type="primary" @click="policyShow = false"
            >我知道了</a-button
          >
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import PlateTitle from "@/components/PlateTitle";
import { getInformation } from "@/api/insure.js";
import { dateFormat } from '@/utils/format.js';
import {
  code,
  phoneCode,
  insureCancel,
  insureInvoice,
  certType,
  getDictInfo,
  giveupapply
} from "@/api/insure.js";
// const querystring = require('querystring');
export default {
  name: "Step2",
  components: {
    PlateTitle
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    insureNotice: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dateFormat,
      data: {},
      orderNo: "",
      statusStr: "",
      isBtnStr: "",
      isVisBtn: false,
      visible: false,
      rulesShow: false,
      policyShow: false,
      form: this.$form.createForm(this, { name: "form"}),
      uuid: "",
      codeImg: "",
      isTime: true,
      time: 60,
      // createDate: '',
      // 发票类型
      invoiceType: "",
      type: "",
      typeArray: [], //选择开票类型
    };
  },
  mounted() {
    this.getInformation();
    this.code();
    this.orderNo = this.getQueryString("orderNo");
    this.type = window.localStorage.getItem("type");
    getDictInfo("invoiceType").then(({ data: data }) => {
        this.typeArray = data.data;
      });
  },
  methods: {
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.img;
        this.uuid = res.uuid;
      });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = "";
      console.log(this.form.instances);
      if (this.form.instances.code.stateValue !== "") {
        phoneCode({
          codeKey: this.uuid,
          code: this.form.instances.code.stateValue,
          phoneNum: this.data.mobile
        }).then(res => {
          if (res === "") {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning("图形验证码不为空");
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
    goBtn(type) {
      let that = this
      if (type === "支付") {
        window.open(this.data.payUrl);
      } else if (type === "退保") {
        this.visible = true;
      } else if (type === "开票") {
        // this.$refs.form.resetFields();
        this.visible = true;
        setTimeout(function () {
          that.form.setFieldsValue({
              email: that.data.invoiceEmail
            });
        },800)
      } else if (type === "下载发票") {
        window.open(this.data.invoiceUrl);
      } else if (type === "取消") {
        // 
        const paramsA = {
          orderNo: this.orderNo,
        };
        this.$confirm('请确认是否取消投保', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' // 可选: success/error/info/warning
          }).then(() => {
              giveupapply(paramsA).then(res => {
                if (res.data.status === 200) {
                  that.$notification.success({ message: '取消成功' });
                } else {
                }
                that.getInformation();
              });

          }).catch(() => {
          });
        // that.$confirm({
        //     title: '请确认是否取消保函',
        //     okText: '确认',
        //     cancelText: '取消',
        //     onOk() {
        //       giveupapply(paramsA).then(res => {
        //         debugger
        //         if (res.data.status === 200) {
        //           that.$notification.success({ message: '取消成功' });
        //           that.getInformation();
        //         } else {
        //         }
        //       });
        //     },
        //     onCancel() {},
        //   });
        
      }
    },
    submit() {
      let that = this
      this.form.validateFields(err => {
        if (!err) {
          if (this.isBtnStr === "退保") {
            const params = {
              responsiblePersonPhone: this.data.mobile,
              orderNo: this.orderNo,
              // phoneCode: this.form.fieldsStore.fields.phoneCode.value,
              cancelReason: this.form.fieldsStore.fields.cancelReason.value
              // accountName: this.form.fieldsStore.fields.accountName.value,
              // bankName: this.form.fieldsStore.fields.bankName.value,
              // bankNo: this.form.fieldsStore.fields.bankNo.value,
            };
            console.log(params);
            insureCancel(params)
              .then(res => {
                console.log(res);
                if (res.status === 200) {
                  this.$notification.success({ message: res.data.message });
                  this.getInformation();
                  this.visible = false;
                  window.location.reload()

                } else {
                  this.$notification.warning({ message: res.data.message });
                }
              })
              .catch(err => {
                this.$notification.error({ message: err.respomessage });
              });
          } else if (this.isBtnStr === "开票") {
            const paramsA = {
              responsiblePersonPhone: that.data.mobile,
              orderNo: that.orderNo,
              // phoneCode: that.form.fieldsStore.fields.phoneCode.value,
              invoiceType: that.invoiceType,
              // invoiceHead: that.form.fieldsStore.fields.invoiceHead.value,
              // cuscCode: that.form.fieldsStore.fields.cuscCode.value,
              invoiceHead: that.data.invoiceHead,
              cuscCode: that.data.creditCode,
              // bankInfo: that.form.fieldsStore.fields.bankInfo.value,
              // bankAcc: that.form.fieldsStore.fields.bankAcc.value,
              // phoneNo: that.form.fieldsStore.fields.phoneNo.value,
              // addInfo: that.form.fieldsStore.fields.addInfo.value,
              email: that.form.fieldsStore.fields.email.value,
              // addressee:that.form.fieldsStore.fields.addressee.value,
              // addresseePhone:that.form.fieldsStore.fields.addresseePhone.value,
              // email:that.form.fieldsStore.fields.email.value,
              // address:that.form.fieldsStore.fields.address.value,
              remark: that.form.fieldsStore.fields.remark.value,
              invoiceStatus: "0"
            };
            insureInvoice(paramsA).then(res => {
              if (res.data.status === 200) {
                this.$notification.success({ message: res.data.message });
                this.visible = false;
                this.getInformation();
              } else {
                this.$notification.warning({ message: res.data.message });
              }
            });
          }
        }
      });
    },
    // 下载
    download() {
      let url = "";
      // const data = this.data;
      // console.log(data.guaranteeStatus, 999111)
      // if (
      //   data.guaranteeStatus === "2" ||
      //   data.guaranteeStatus === "11" ||
      //   data.guaranteeStatus === "12"
      // ) {
      //   url = this.data.preSignDownloadUrl;
      // } else if (
      //   data.guaranteeStatus === "22" ||
      //   data.guaranteeStatus === "31" ||
      //   data.guaranteeStatus === "32"
      // ) {
      //   url = this.data.signDownloadUrl;
      // }
      if(this.data.signDownloadUrl) {
        url = this.data.signDownloadUrl
      } else {
        url = this.data.preSignDownloadUrl
      }
      window.open(encodeURI(url), "_blank");
    },
    getInformation() {
      let that = this
      this.orderNo = this.getQueryString("orderNo");
      getInformation({
        orderNo: this.orderNo
      }).then(response => {
        const res = response.data;
        // this.data = res.data;
        this.data = res;
        console.log("===-", res);

        if (res.status == "14") {
          this.statusStr = res.guaranteeStatusStr;
        } else {
          this.statusStr = res.statusStr;
        }
        this.isVisBtn = true;
        if (res.isInsureCancel && res.surrenderBut) {
          this.isBtnStr = "退保";
        }
        //  
        else if (res.isInsureInvoice && res.invoiceBut&&(that.data.thirdId==11||that.data.thirdId==26||that.data.thirdId==33)) {
          this.isBtnStr = "开票";
          // that.form.fieldsStore.fields.email.value = res.invoiceEmail
          
          that.invoiceType = res.invoiceType
        }
        else if ((res.status === "11" || res.status === "13") && res.payBut) {
          this.isBtnStr = "支付";
        }  else {
          this.isVisBtn = false;
        }
        if (res.invoiceUrl && res.invoiceBut&&(that.data.thirdId==11||that.data.thirdId==26||that.data.thirdId==33)) {
          this.isBtnStr = "下载发票";
          this.isVisBtn = true;
        }
        if(res.status == "5"){
          // 审核中
          setTimeout(function(){
            that.getInformation()
          }, 4000)
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.test {
  position: absolute;
  transform: translate(100px, -65px);
  color: #666;
}

.content_head {
  font-size: 18px;
  color: rgb(51, 51, 51);
}

.p_red {
  color: #ff0000;
  margin-top: 8px;
}

.p_tip {
  width: 100%;
  background: #f2f2f2;
  text-align: center;
  padding: 8px;
  margin-bottom: 10px;
}
.p_tips {
  width: 100%;
  height: 40px;
}

.icon {
  width: 8em;
  height: 8em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.logo_box {
  width: 100%;
  height: 94px;
  // background: red;
  img {
    max-width: 100%;
    height: 80%;
  }
}

.order {
  display: flex;
  align-items: center;
  margin: 20px 0 30px;

  .bg-purple {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      font-size: 20px;
    }

    a {
      font-size: 20px;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }

  .bg-purple-light {
    display: flex;
    flex: 3;

    h3 {
      color: #df263d;
    }

    div {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      div {
        display: flex;
        justify-content: center;
        // transform: translateY(100px);
      }
    }
  }

  .custom-btn {
    width: 130px;
    height: 40px;
    color: #fff;
    border-radius: 5px;
    padding: 10px 25px;
    font-family: "Lato", sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
      7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
    outline: none;
  }

  /* 4 */
  .btn-4 {
    // background-color: #4dccc6;
    // background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);
    background: rgb(0, 172, 238);
    background: linear-gradient(
      0deg,
      rgba(0, 172, 238, 1) 0%,
      rgba(2, 126, 251, 1) 100%
    );
    line-height: 42px;
    padding: 0;
    border: none;
  }

  .btn-4:hover {
    // background-color: #89d8d3;
    // background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);
    background-color: rgb(0, 172, 238);
    background-image: linear-gradient(
      315deg,
      rgb(0, 172, 238) 0%,
      rgba(2, 126, 251, 1) 74%
    );
  }

  .btn-4:before,
  .btn-4:after {
    position: absolute;
    content: "";
    right: 0;
    top: 0;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),
      -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
      inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),
      inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
    transition: all 0.3s ease;
  }

  .btn-4:before {
    height: 0%;
    width: 0.1px;
  }

  .btn-4:after {
    width: 0%;
    height: 0.1px;
  }

  .btn-4:hover:before {
    height: 100%;
  }

  .btn-4:hover:after {
    width: 100%;
  }
}

/deep/ .ant-row {
  display: flex;
  justify-content: center;
}

/deep/ .ant-form-item {
  margin-bottom: 10px !important;
}

/deep/ .ant-form-item-control {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*加宽度width属来兼容部分浏览*/
}

.code {
  img {
    position: absolute;
    cursor: pointer;
    left: 180px;
    top: -5px;
    height: 30px;
  }

  a,
  span {
    position: absolute;
    width: 80px;
    left: 192px;
  }
}

.rules ::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 716px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}
.Invoicing ::v-deep .ant-modal-content {
  width: 700px !important;
}
::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.contents {
  // height: 152px;
  padding: 20px;
  font-size: 18px;
}
::v-deep .ant-form-item-label {
  text-align: left !important;
  padding-left: 45px !important;
}

::v-deep .ant-form label {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.447);
}

::v-deep .ant-form-item-children {
  font-size: 14px;
  color: rgb(51, 51, 51);
}
.polic ::v-deep .ant-modal-content {
  width: 560px !important;
  height: 356px !important;
  padding: 15px 50px;
  box-sizing: border-box;
}
.polic {
  .down {
    margin-top: 10px;
    text-align: right;
  }
}


.downloadBtn {
  position: absolute;
  transform: translateX(900px);
  left:25px;
  top: 120px;
}
.downloadBtnTwo{
  position: absolute;
  transform: translateX(900px);
  left:60px;
  top: 120px;
}
</style>

